import mutations from './patientTrafficByDoctor.mutations'
import actions from './patientTrafficByDoctor.actions'
import getters from './patientTrafficByDoctor.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
